export default __webpack_public_path__ + "2e1893b0cf379205a24414b17956eae9.svg";